import React, { useState, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Login from './Login';
import SessionExtender from './SessionExtender';
import useSessionMonitor from '../hooks/useSessionMonitor';
import useIdleTimer from '../hooks/useIdleTimer';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated } = useSelector((state) => state.auth);
  const location = useLocation();
  const [showLogin, setShowLogin] = useState(!isAuthenticated);
  const { showExtender, handleExtendSession, handleLogout } = useSessionMonitor();
  
  // Track user activity and reset session timer
  useIdleTimer();

  // Update showLogin state when authentication changes
  useEffect(() => {
    setShowLogin(!isAuthenticated);
  }, [isAuthenticated]);

  // If not authenticated, show login modal
  if (!isAuthenticated) {
    return (
      <>
        {showLogin && (
          <Login
            onClose={() => {
              setShowLogin(false);
              // Redirect to home if user closes login without authenticating
              window.location.href = '/';
            }}
            onLoginSuccess={() => {
              setShowLogin(false);
              // After successful login, the component will re-render with isAuthenticated = true
            }}
          />
        )}
        {/* Show a placeholder while login modal is open */}
        <div className="min-h-screen bg-gradient-to-br from-blue-50 via-purple-50 to-pink-50 flex items-center justify-center">
          <div className="text-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
            <p className="text-gray-600">Please login to continue...</p>
          </div>
        </div>
      </>
    );
  }

  // If authenticated, render the protected content with session monitoring
  return (
    <>
      {children}
      {showExtender && (
        <SessionExtender
          onExtend={handleExtendSession}
          onLogout={handleLogout}
        />
      )}
    </>
  );
};

export default ProtectedRoute;
